import Svg, { G } from 'react-native-svg'

export const Divider = ({ height, width, color }: { height: any; width: any; color: any }) => {
  return (
    <Svg id="Dividers" width={width} height={height} viewBox="0 0 2 49">
      <G id="Divider" transform="translate(-595 -528)" opacity="0.2">
        <rect
          id="Rectangle_1092"
          data-name="Rectangle 1092"
          width="2"
          height="25"
          rx="1"
          transform="translate(595 528)"
          fill={color}
        />
        <rect
          id="Rectangle_1093"
          data-name="Rectangle 1093"
          width="2"
          height="13"
          rx="1"
          transform="translate(595 557)"
          fill={color}
        />
        <rect
          id="Rectangle_1094"
          data-name="Rectangle 1094"
          width="2"
          height="4"
          rx="1"
          transform="translate(595 573)"
          fill={color}
        />
      </G>
    </Svg>
  )
}
